
import watermelon from "./Assets/images/Products/Shop-1.webp";
import tomato from "./Assets/images/Products/Shop-2.webp";
import coriander from "./Assets/images/Products/Shop-3.webp";
import egg from "./Assets/images/Products/Shop-4.webp";
import chickenBrest from "./Assets/images/Products/Shop-5.webp";
import badam from "./Assets/images/Products/Shop-6.webp";
import nutCookies from "./Assets/images/Products/Shop-7.webp";
import TMRice from "./Assets/images/Products/Shop-8.webp";
import flowerMushroom from "./Assets/images/Products/Shop-9.webp";
import potato from "./Assets/images/Products/Shop-10.webp";
import freshMeat from "./Assets/images/Products/Shop-11.webp";
import fishCurry from "./Assets/images/Products/Shop-13.webp";

 const productCardData = [
    {
      id: 1212,
      title: "Watermelon",
      img: watermelon,
      price: 60,
      rating: 4,
    },
    {
      id: 1213,
      title: "Tomato",
      img: tomato,
      price: 40,
      rating: 3,
    },
    {
      id: 1214,
      title: "Coriander",
      img: coriander,
      price: 150,
      rating: 4,
    },
    {
      id: 1215,
      title: "Egg",
      img: egg,
      price: 220,
      rating: 5,
    },
    {
      id: 1216,
      title: "Chicken Brest",
      img: chickenBrest,
      price: 350,
      rating: 5,
    },
    {
      id: 1217,
      title: "Badam",
      img: badam,
      price: 300,
      rating: 4,
    },
    {
      id: 1218,
      title: "Nut Cookies",
      img: nutCookies,
      price: 50,
      rating: 5,
    },
    {
      id: 1219,
      title: "Tm Rice",
      img: TMRice,
      price: 80,
      rating: 4,
    },
    {
      id: 1220,
      title: "Mushroom",
      img: flowerMushroom,
      price: 60,
      rating: 3,
    },
    {
      id: 1221,
      title: "Potato",
      img: potato,
      price: 50,
      rating: 4,
    },
  
    {
      id: 1222,
      title: "Fresh Meat",
      img: freshMeat,
      price: 400,
      rating: 3,
    },
    {
      id: 1223,
      title: "Fish Curry",
      img: fishCurry,
      price: 120,
      rating: 5,
    }
  ];

  export default productCardData;